var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPokerSpeedSlow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.114 11.267c.789.17.789 1.295 0 1.466L5.41 15.7a.75.75 0 01-.909-.733V9.033a.75.75 0 01.909-.733l13.705 2.967z",
    fill: "currentColor"
  })));
}
SvgPokerSpeedSlow.displayName = 'PokerSpeedSlow';
export default SvgPokerSpeedSlow;